import React, { useCallback, useEffect, useRef, useState } from "react";
import { styled, css } from "styled-components";
import { Colors } from "../../styles";
import { useToastDispatcher } from "./hooks";
import { TransparentIconButton } from "../TransparentIconButton";
import { Close } from "../../icons";
import { TextLink } from "../Text";
import rem from "../../utils/rem";
const StyledToast = styled.div `
  color: ${Colors.WHITE};
  background: ${Colors.GRAY_DARKEST};
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: ${rem(16)} ${rem(24)};
  font-size: ${rem(14)};
  line-height: ${rem(20)};

  transition: visibility 0.3s linear, opacity 0.3s linear;
  visibility: hidden;
  opacity: 0;

  display: flex;
  align-items: center;
  justify-content: space-between;

  ${(props) => props.isVisible &&
    css `
      visibility: visible;
      opacity: 1;
    `};
`;
const Message = styled.div `
  color: ${Colors.WHITE};
  margin-right: ${rem(22)};
`;
const Actions = styled.div `
  height: ${rem(40)};
  display: flex;
  align-items: center;
`;
const ActionSep = styled.div `
  height: ${rem(40)};
  width: 1px;
  margin: 0 ${rem(16)};
  background: ${Colors.GRAY_DARK};
`;
export const Toast = ({ toast }) => {
    const [visible, setVisible] = useState(false);
    const { clearToast, defaults } = useToastDispatcher();
    const timers = useRef({});
    const timeout = toast.timeout ?? defaults.defaultTimeout;
    const shouldRemoveAutomatically = timeout !== 0;
    const showCloseBtn = toast.showCloseBtn ?? defaults.defaultShowCloseBtn;
    const showActionButton = toast.onActionClick;
    const toastActionButtonTitle = toast.actionBtnName ?? defaults.defaultActionBtnName;
    const pauseAutoHide = toast.pauseAutoHideOnHover ?? defaults.defaultPauseAutoHideOnHover;
    const detachTimers = () => {
        clearTimeout(timers.current.visibleTimer);
        clearTimeout(timers.current.animTimer);
    };
    const close = useCallback((actor) => {
        setVisible(false);
        timers.current.animTimer = window.setTimeout(() => {
            if (toast.onClose) {
                toast.onClose(actor);
            }
            clearToast(toast);
        }, 300);
    }, [clearToast, toast]);
    const setTimers = useCallback(() => {
        detachTimers();
        if (shouldRemoveAutomatically) {
            timers.current.visibleTimer = window.setTimeout(() => {
                close("auto");
            }, timeout);
        }
    }, [close, shouldRemoveAutomatically, timeout]);
    useEffect(() => {
        setVisible(true);
        setTimers();
        return function cleanup() {
            detachTimers();
        };
    }, [setTimers]);
    const onActionBtnClick = (event) => {
        if (toast.closeOnActionClick) {
            detachTimers();
            close("action");
        }
        if (toast.onActionClick) {
            toast.onActionClick(event);
        }
    };
    const onCloseBtnClick = () => {
        detachTimers();
        close("user");
    };
    return (React.createElement(StyledToast, { onMouseEnter: pauseAutoHide ? detachTimers : undefined, onMouseLeave: pauseAutoHide ? setTimers : undefined, isVisible: visible },
        React.createElement(Message, null, toast.message),
        (showCloseBtn || showActionButton) && (React.createElement(Actions, null,
            showActionButton && (React.createElement(TextLink, { theme: "darkMode", onClick: onActionBtnClick }, toastActionButtonTitle)),
            showActionButton && showCloseBtn && React.createElement(ActionSep, null),
            showCloseBtn && (React.createElement(TransparentIconButton, { "data-cy": "toast-btn-close", iconColor: "WHITE", size: 11, type: "button", icon: Close, onClick: onCloseBtnClick }))))));
};
export default Toast;
//# sourceMappingURL=Toast.js.map